/** Part of the decision a return note refers to ("موضع الملاحظة"). */
export enum DecisionNoteSection {
	Facts = 1,
	Reasons = 2,
	Verdict = 3,
	Penalty = 4,
	MemberNotes = 5,
}
